import { render, staticRenderFns } from "./SubSector.vue?vue&type=template&id=a4d8d3f2"
import script from "./SubSector.vue?vue&type=script&lang=js"
export * from "./SubSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports